import "./index.css";
import { Row } from "react-bootstrap";

const ContactCard = ({ icon, title, description, link }) => {
	return (
		<div className="info-card h-100">
			<a target="_blank" rel="noreferrer" href={link}>
				<Row className="mb-4 align-items-center justify-content-center">
					<div className="img-bg">
						<img src={icon} alt="" />
					</div>
				</Row>
				<Row className="gy-1 align-items-center justify-content-center">
					<h5 className="card-title my-1 text-center">{title}</h5>
					<p className="card-text text-center"> {description}</p>
				</Row>
			</a>
		</div>
	);
};

export default ContactCard;
